// extracted by mini-css-extract-plugin
module.exports = {"Nav":"DesktopNavigation_Nav__2zwEo","Disabled":"DesktopNavigation_Disabled__1E16i"};